import classnames from "classnames";
import * as React from "react";

import {
  COLORS,
  IconClickHandler
} from "features/common/components/ClickableText";

import styles from "./BackButtonWithText.module.scss";

export { COLORS };

type Props = {
  text: string | React.ReactNode;
  onClick: () => void;
  className?: string;
  color?: string;
  type?: string;
};

export default function BackButtonWithText({
  text = "Back",
  onClick,
  color = COLORS.BLACK,
  className
}: Props) {
  return (
    <IconClickHandler
      onClick={onClick}
      className={classnames(styles.link, className)}
      text={text}
      color={color as any}
      icon="fa fa-angle-left"
    />
  );
}
